/*
* 组管理组件
* zxw
* 创建时间：
* 修改时间：2026-08-11
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    theme,
    message,
    Table,
    Input,
    Select,
    Button,
    Space,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    ShowIPModal,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';

import Entity from './GroupEntity';
import GroupUserSetEntity from './GroupUserSetEntity.js';
import GroupAuthoritySetEntity from './GroupAuthoritySetEntity';

const MODULENAME = CNF.navItems[2].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[2].ptn;
const MODULENAME_URL = CNF.navItems[2].url;

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, setOpen, refresh } = props;

    const {
        token: {
            pageSize,

        },
    } = theme.useToken();

    const update = useCallback((record) => {
        setOpen(true, record);
    }, [setOpen]);

    const [record, setRecord] = useState(null);
    const [userOpen, setUserOpen] = useState(false);
    const [authorityOpen, setAuthorityOpen] = useState(false);

    const handleSetUserOpen = useCallback((value) => {
        setUserOpen(value);
    }, []);

    const handleSetAuthorityOpen = useCallback((value) => {
        setAuthorityOpen(value);
    }, []);


    /**
     * 显示用户设置弹框
     */
    const showUserSet = useCallback((record) => {
        setRecord(record);
        setUserOpen(true);
    }, [])


    /**
     * 显示权限设置弹框
     */
    const showAuthoritySet = useCallback((record) => {
        setRecord(record);
        setAuthorityOpen(true);
    }, [])

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case '成员' + CNF.actionName.SET:
                showUserSet(record);
                break;
            case '权限' + CNF.actionName.SET:
                showAuthoritySet(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.name, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [refresh, update, showUserSet, showAuthoritySet]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_user_set') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_authority_set') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );

    const columns = useMemo(() => [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        { title: '团队名', dataIndex: 'groupname', key: 'groupname', },
        { title: '显示名', dataIndex: 'displayname', key: 'displayname', },
        { title: '角色', dataIndex: 'rolename', key: 'rolename', },
        { title: '管理员', dataIndex: 'username', key: 'username', },
        { title: '描述', dataIndex: 'description', key: 'description', },
        { title: '状态', key: 'status', dataIndex: 'status', width: CNF.tableStatusColumnWidth, },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        {
            title: '', key: 'operation', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation]);
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount}条`,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
            {userOpen && <GroupUserSetEntity
                record={record}
                open={userOpen}
                setOpen={handleSetUserOpen}
            />
            }
            {authorityOpen && <GroupAuthoritySetEntity
                record={record}
                open={authorityOpen}
                setOpen={handleSetAuthorityOpen}
            />
            }
        </>
    );
}

const Group = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState(CNF.status[0].value);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [groupname, setGroupname] = useState('');

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const handleGroupnameChange = useCallback((e) => {
        setGroupname(e.target.value);
        setCurrentIndex(1);
    }, []);

    const setOpenModal = useCallback((value, record) => {
        setOpen(value);
        setRecord(record || null);
    }, []);

    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            groupname,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, status, groupname]);

    // 按钮权限判断
    const hasCreate = btnLists.includes(MODULENAME_PTN + '_create');

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input
                    onChange={handleGroupnameChange}
                    placeholder='团队名'
                    value={groupname}
                />
                <Select
                    allowClear
                    placeholder='状态'
                    style={{ width: '100%' }}
                    onChange={handleStatusChange}
                    value={status ?? undefined}
                    options={CNF.status.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                {hasCreate && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={() => {
                            create();
                        }}>
                        {CNF.actionName.CREATE}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
            />
        </>
    );
}

export default Group